/**
 * Relógio injetável. Toda regra que depende de "agora" (urgência de fase,
 * aging de estoque, dias em reserva) passa por aqui, nunca por `Date.now()`.
 *
 * Na POC os mocks estão congelados em 2026-05-09 e a UI usava o relógio real,
 * então tudo aparecia atrasado. Enquanto os dados forem mock, o app fixa o
 * relógio na mesma data (`setClock`); com API real, volta ao relógio do sistema.
 */
let nowFn: () => Date = () => new Date();

export function now(): Date {
  return nowFn();
}

export function setClock(fn: (() => Date) | null): void {
  nowFn = fn ?? (() => new Date());
}
